export const enum Social {
  LinkedIn = 'linkedin',
  Facebook = 'facebook',
  Instagram = 'instagram'
}
